import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-deep-black via-forest-green/30 to-deep-black"></div>
      
      {/* Decorative Elements */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-20 right-20 w-96 h-96 bg-copper/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 left-20 w-96 h-96 bg-forest-green/20 rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 py-32 lg:py-40">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div className="text-center lg:text-left space-y-8">
            {/* Badge */}
            <div className="inline-flex items-center gap-2 px-4 py-2 border border-copper/40 rounded-full">
              <span className="text-copper text-xs font-medium tracking-wider uppercase">Est. 2024</span>
              <span className="text-copper/40">•</span>
              <span className="text-copper text-xs font-medium tracking-wider uppercase">Eustis, FL</span>
            </div>

            {/* Headline */}
            <h1 className="font-serif text-5xl lg:text-7xl text-white leading-tight">
              Elevate Your <span className="text-copper">Smoke Experience</span> in Eustis, Florida
            </h1>

            {/* Subheadline */}
            <p className="text-gray-400 text-lg lg:text-xl leading-relaxed max-w-2xl">
              Premium vapes, fine glass, hookah, hand blown glass, and curated accessories. Experience luxury and quality at Central Florida's premier smoke shop.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start pt-4">
              <a
                href="https://www.google.com/maps/place/1321+S+Bay+St,+Eustis,+FL+32726"
                target="_blank"
                rel="noopener noreferrer"
                className="px-8 py-4 bg-copper text-deep-black font-semibold rounded-full hover:bg-copper/90 transition-all duration-300 hover:shadow-lg hover:shadow-copper/30 whitespace-nowrap cursor-pointer text-center"
              >
                Visit Our Store
              </a>
              <Link
                to="/products"
                className="px-8 py-4 border-2 border-copper text-copper font-semibold rounded-full hover:bg-copper hover:text-deep-black transition-all duration-300 whitespace-nowrap cursor-pointer text-center"
              >
                Browse Categories
              </Link>
            </div>
          </div>

          {/* Right Visual */}
          <div className="relative hidden lg:block">
            <div className="relative w-full h-[600px]">
              {/* Main Image */}
              <div className="absolute inset-0 rounded-2xl overflow-hidden">
                <img
                  src="https://public.readdy.ai/ai/img_res/a59a8856bba12fbed38e9821276a9d80.jpg"
                  alt="Premium Smoke Shop Products"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-deep-black/60 via-transparent to-transparent"></div>
              </div>

              {/* Floating Card */}
              <div className="absolute bottom-8 left-8 right-8 bg-forest-green/90 backdrop-blur-sm p-6 rounded-xl border border-copper/20">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-copper rounded-full">
                    <i className="ri-star-fill text-deep-black text-xl"></i>
                  </div>
                  <div>
                    <div className="flex items-center gap-1 mb-1">
                      {[...Array(5)].map((_, i) => (
                        <i key={i} className="ri-star-fill text-copper text-sm"></i>
                      ))}
                    </div>
                    <p className="text-white font-medium">Rated 5.0 by 200+ Customers</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-copper text-2xl"></i>
      </div>
    </section>
  );
}
